import { usePersonNavLinks } from "@/pages/people/[pgaId]/_utils";
import MobileNavigation from "./MobileNavigation";

export interface MobilePersonNavigationProps {
  pgaId: string;
}

export default function MobilePersonNavigation({ pgaId }: MobilePersonNavigationProps) {
  const navLinks = usePersonNavLinks(pgaId);

  return <MobileNavigation links={navLinks} section="Manage Person" testId="mobile-person-navigation" />;
}
